import { Direction, directions } from './types'

export type IsDirection = (value: Direction) => value is Direction

export const isDirection = (value: Direction | undefined): value is Direction =>
  directions.includes(value)
